
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'
import { useVoice } from '../context/voice/VoiceContext'

type Props = {
    thisQuestion?: ObjectStringKeyAnyValue | null
    isAnswerPending?: boolean
}


function IsListening({
    thisQuestion,
    isAnswerPending 
}: Props) {

    const { isRecognizerRunning, questionTypesIncompatibleWithVoiceMode, microphonePermission } = useVoice()
    const questionFormat = thisQuestion && thisQuestion.QuestionFormat 


    // don't show if voice mode is switched off
    if (!isRecognizerRunning) {
        return null
    }

    // don't show if this is not in a question
    if (!thisQuestion) {
        return null
    }

    // don't show if isAnswerPending is false
    if (isAnswerPending === false) {
        return null
    }

    // show a warning if this question is incompatible with voice mode
    if (questionTypesIncompatibleWithVoiceMode.includes(questionFormat)) {
        return <div className={`pt-2 flex flex-col items-center gap-1`}>
            <p className={`text-xs text-red-500`}>⚠️ This question type is not compatible with voice mode.</p>
        </div>
    }

    // show a warning if voice mode is enabled but microphone permission is not granted
    if (microphonePermission !== 'granted') {
        return <div className={`pt-2 flex flex-col items-center gap-1`}>
            <p className={`text-xs text-red-500`}>⚠️ Voice mode has been enabled, but microphone permission is not granted.</p>
        </div>
    }

    return <div className={`pt-2 flex flex-col items-center gap-1`}>
        <p className={`text-xs animate-pulse`}>🎤 Voice mode enabled. Listening...</p>
    </div>
}

export default IsListening